import type { GetOnboardingStatusQuery } from "@src/gql/graphql";
import { OnboardingStep } from "@src/gql/graphql";

export type OnboardingOverview = NonNullable<
	GetOnboardingStatusQuery["users"]["onboarding"]["overview"]
>;

export function selectIntroVideosStep(
	overview: OnboardingOverview | null | undefined,
) {
	return overview?.steps.find((s) => s.step === OnboardingStep.IntroVideos);
}

export function selectFirstTimeBoardCreatedStep(
	overview: OnboardingOverview | null | undefined,
) {
	return overview?.steps.find(
		(s) => s.step === OnboardingStep.FirstTimeBoardCreated,
	);
}
